import __ from "ramda/es/__";
import prop from "ramda/es/prop";
import { fieldTypes } from '../../../constants';
import autocomplete from './autocomplete';
import checkbox from './checkbox';
import datePicker from './datePicker';
import datePickerMui from './datePickerMui';
import fileInput from './fileInput';
import radio from './radiogroup';
import select from './select';
import spinner from './spinner';
import switchField from './switch';
import tagsInput from './tagsInput';
import textField from './textField';
const creatorDefinition = {
    [fieldTypes.TEXT_FIELD]: textField,
    [fieldTypes.SELECT]: select(fieldTypes.SELECT),
    [fieldTypes.SELECT_CODELIST]: select(fieldTypes.SELECT_CODELIST),
    [fieldTypes.DATE_PICKER]: datePicker,
    [fieldTypes.DATE_PICKER_MUI]: datePickerMui(fieldTypes.DATE_PICKER_MUI),
    [fieldTypes.KEYBOARD_DATE_PICKER_MUI]: datePickerMui(fieldTypes.KEYBOARD_DATE_PICKER_MUI),
    [fieldTypes.DATE_TIME_PICKER_MUI]: datePickerMui(fieldTypes.DATE_TIME_PICKER_MUI),
    [fieldTypes.TIME_PICKER_MUI]: datePickerMui(fieldTypes.TIME_PICKER_MUI),
    [fieldTypes.CHECKBOX]: checkbox,
    [fieldTypes.RADIO]: radio,
    [fieldTypes.FILE_INPUT]: fileInput,
    [fieldTypes.SPINNER]: spinner,
    [fieldTypes.SWITCH]: switchField,
    [fieldTypes.TAGS_INPUT]: tagsInput,
    [fieldTypes.AUTOCOMPLETE]: autocomplete(fieldTypes.AUTOCOMPLETE),
    [fieldTypes.AUTOCOMPLETE_CODELIST]: autocomplete(fieldTypes.AUTOCOMPLETE_CODELIST)
};
export default prop(__, creatorDefinition);
